import { useState } from 'react';
import Button from '../Button.jsx';
import EatTab from './home/EatTab';
import LearnTab from './home/LearnTab';
import LifeTab from './home/LifeTab';
import PlayTab from './home/PlayTab';
import RandomTab from './home/RandomTab';
import WatchTab from './home/WatchTab';
import Business from './home/Business.jsx';

export default function HomePageTabs() {
  const [activeTab, setActiveTab] = useState(''); // Initially empty

  const handleContent = (value) => {
    setActiveTab(value);
  };

  return (
    <div className="w-full flex flex-col items-center">
      {/* Responsive Tab Navigation */}
      <div className="w-full md:w-4/5 lg:w-2/3 sticky top-0 z-10 bg-primary">
        <ul className="flex overflow-x-auto no-scrollbar items-center justify-between md:justify-center gap-2 lg:gap-9 sm:gap-4 px-4 py-2 md:py-3 border-b-2 border-secondary">
          {[
            { label: 'Watch', value: 'watch' },
            { label: 'Eat', value: 'eat' },
            { label: 'Life', value: 'life' },
            // { label: 'business', value: 'business' },
            { label: 'Learn', value: 'learn' },
            { label: 'Play', value: 'play' },
          ].map((tab) => (
            <li key={tab.value} className="flex-shrink-0">
              <Button
                type="button"
                variant="tab"
                isActive={activeTab === tab.value}
                onClick={() => handleContent(tab.value)}
                className={`px-4 py-1 flex justify-center items-center text-lg font-semibold rounded-md transition-all duration-300 ${
                  activeTab === tab.value
                    ? 'text-primary bg-secondary shadow-lg'
                    : 'text-gray-300 hover:text-white hover:bg-secondary/30'
                }`}
              >
                {tab.label}
              </Button>
            </li>
          ))}
        </ul>
      </div>

      {/* Responsive Tab Content */}
      <div className="w-full bg-primary text-center min-h-[300px] mt-4 px-2 rounded-lg shadow-lg transition-all duration-500">
        {activeTab === 'watch' ? (
          <WatchTab />
        ) : activeTab === 'eat' ? (
          <EatTab />
        ) : activeTab === 'learn' ? (
          <LearnTab />
        ) : activeTab === 'life' ? (
          <LifeTab />
        ) : activeTab === 'play' ? (
          <PlayTab />
        ) : activeTab === 'business' ? (
          <Business />
        ) : (
          <RandomTab /> // Display RandomTab when no tab is selected
        )}
      </div>
    </div>
  );
}
